const Require = () => {
  return <span style={{ color: 'red' }}>*</span>;
};
export default Require;
